// extracted by mini-css-extract-plugin
module.exports = {"marginPermanent":"AddressPage_marginPermanent___79T6","marginPresent":"AddressPage_marginPresent__GSipX","button":"AddressPage_button__3cMXq"};